import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import TicketSalidaCardImg from "../../components/UmmIApps/Cards/TicketSalidaCardImg.png";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaEvaluacion from "../../components/Form/Fields/TemaEvaluacion";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const TicketSalidaPage = () => {

  const {
    nivelId,
    materiaId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();


  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("ticket_salida", { promptData });
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      caracterizacion: "",
      condiciones_contexto: "",
      tema_evaluacion: "",
    };
    handleInitialPromptData(init, "ticket_salida");
    setTextoInicial(
      "Te presentamos 6 opciones diferentes de tickets de salida, organizadas en 3 categorías, diseñadas para usar al final de tu clase. Puedes elegir y editar cualquiera de las opciones según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  // Te presentamos seis opciones diferentes de tickets de salida, organizadas en
  // tres categorías, diseñadas para usar al final de tu clase. Puedes elegir y editar cualquiera de las opciones según tus necesidades.
  // Puedes volver a “Mostrar campos” para ajustar los parámetro que desees,pedirle a UmmIA “Volver a generar” la propuesta o “Copiar” el texto
  // para poder trabajarlo en otra aplicación.

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={TicketSalidaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Ticket de salida"
        description="Crea actividades y preguntas rápidas para favorecer la reflexión de tus estudiantes, la consolidación de los aprendizajes y ganar información que ayude a la retroalimentación."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
        
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
          </Grid>
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}sx={{ mt: 3 }}>
          <TemaEvaluacion />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CondicionesContexto />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Caracterizacion />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default TicketSalidaPage;
